<template>
  <b-container fluid>
    <b-form @submit.stop.prevent="signin_email">
      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="email" autocomplete='email' type='email' required placeholder="Email"></b-form-input>
      </b-form-group>

      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="password" autocomplete='current-password' type='password' required placeholder="Password"></b-form-input>
      </b-form-group>

      <LoadingButton variant="primary" :loading="loading" block @click="signin_email">Login</LoadingButton>
    </b-form>

    <b-button v-if="$route && $route.params && $route.params.has_google" class='google-button mt-3 mb-2' @click="signin_google" block><img class='google-logo' src="@/assets/google.svg" height="24px" width="24px"/> Login with Google</b-button>
  </b-container>
</template>

<script>

import { db, auth, _firebase } from '@/main.js'
import AuthMixin from "@/mixins/Auth.js"

export default {
  metaInfo: {title: 'Login'},
  mixins: [AuthMixin],
  props: ['profile'],
  data() {
    return {
      email: this.$route.params.from_email || '',
      password: '',
      loading: false
    }
  },
  methods: {
    async signin_email() {
      this.loading = true
      let result
      try {
        result = await auth.signInWithEmailAndPassword(this.email, this.password)
      } catch (error) {
        this.loading = false
        return this.$swal({title: 'Try again', text: error.message, icon: 'warning'})
      }

      this.loading = false
    },
  },
  created() {
    // Confirm the link is a sign-in with email link.
    if (auth.isSignInWithEmailLink(window.location.href)) {
      let email = this.$route.query.email
      console.log(email, window.location.href)
      // The client SDK will parse the code from the link for you.
      try {
        auth.signInWithEmailLink(email, window.location.href)
      } catch (err) {
        console.warn(err)
      }
    }
  }
}
</script>

<style scoped>

</style>
